import {IsJsonString} from "./json";
import {Overlay} from "../ui/overlay";
import {Div, Text} from "./dom";
import {TwoFactorInput} from "../elements/2fa-input";

async function DoRequest(method, url, data = null, headers = {}) {
    if (url == null) {
        url = method;
        method = "GET";
    }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        for (var header in headers) {
            xhr.setRequestHeader(header, headers[header]);
        }
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(resolve(JSON.parse(xhr.responseText, function (k, v) {
                    // Check if the value is an object
                    if (typeof v === "object" && v !== null) {
                        return v;  // Return the object as is
                    }

                    // Check if the value is a boolean (true or false)
                    if (v === true || v === false) {
                        return v;
                    }

                    // Check if the value is a non-numeric string
                    if (isNaN(v)) {
                        return v;  // Return the string as is
                    }

                    // Otherwise, parse the value as an integer
                    return parseInt(v, 10);
                })));
            } else {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: xhr.status,
                statusText: xhr.statusText
            });
        };
        if (data) {
            var formData = new FormData();
            for (var key in data) {
                formData.append(key, data[key]);
            }
            xhr.send(formData);
        } else {
            xhr.send()
        }
    });
}


async function AuthRequest(url, data) {
    var r = await DoRequest("POST", url, data);
    console.log(r);

    if (r['success'] === true || r['message'] !== "mfa") {
        return r;
    }

    var div = Div("div", "panel mfa");
    if(r['content']['type'] == "2fa") {
        div.appendChild(Text("h1", "Please input your 2FA code"));
    }
    if(r['content']['type'] == "email") {
        div.appendChild(Text("h1", "We've emailed you a code, please input it"));
    }

    var input = document.createElement("mfa-input");
    div.appendChild(input);



    var error = document.createElement("error");
    div.appendChild(error);


    // Show the overlay
    var overlay = new Overlay(div);

    setTimeout(() => {
        input.select();
    }, 100)


    // Create a new promise to handle the 2FA input and request
    let mfaPromise = new Promise((resolve, reject) => {
        input.callback = async () => {
            try {
                input.classList.add("disabled");
                data.mfa = input.retrieveOTP();
                if(typeof(r['content']['code']) !== "undefined") {
                    data.mfacode = r['content']['code'];
                }
                let mfaResponse = await DoRequest("POST", url, data);
                if(mfaResponse.success == "true") {
                    overlay.close();
                    resolve(mfaResponse);
                } else {

                    input.classList.remove("disabled");
                    if(mfaResponse.content == "mfa") {

                        error.innerText = mfaResponse.message;
                        setTimeout(() => {
                            input.clear();
                        }, 400)
                    } else {
                        resolve(mfaResponse);
                        overlay.close();
                    }
                }
            } catch (error) {
                reject(error);
            }
        };
    });


    // Wait for the 2FA promise to resolve and return the response
    r = await mfaPromise;
    return r;
}


export {DoRequest, AuthRequest};